import React, { useState } from "react"
import { UseFormRegister, UseFormGetFieldState, UseFormWatch, UseFormSetValue } from "react-hook-form"

import { BasicTicketCard } from "../cards/basic-ticket-card"
import { PlaceOrderFormData, Ticket, OrderData } from "types"


interface BasicFormsHandlerProps {
  orderData: OrderData | null | undefined
  register: UseFormRegister<PlaceOrderFormData>
  getFieldState: UseFormGetFieldState<PlaceOrderFormData>
  typeRankOrder?: number[]
  watch?: UseFormWatch<PlaceOrderFormData>
  setValue?: UseFormSetValue<PlaceOrderFormData>
}


const BasicFormsHandler: React.FC<BasicFormsHandlerProps> = ({
  orderData,
  register,
  getFieldState,
  typeRankOrder,
  watch,
  setValue,
}) => {
  // Track "same as contact" state per ticket type
  const [isSameAsContact, setIsSameAsContact] = useState<Record<string, boolean>>({})

  // Group tickets by type while preserving original order
  const ticketsByType: Record<string, Ticket[]> = {}
  const initialTypeOrder: string[] = []
  
  orderData?.ticket_set?.forEach((ticket: Ticket) => {
    const typeName = String(ticket.ticket_type)
    if (!ticketsByType[typeName]) {
      ticketsByType[typeName] = []
      initialTypeOrder.push(typeName)
    }
    ticketsByType[typeName].push(ticket)
  })

  // Derive type order based on published ticket type rank order when available
  const typeOrder: string[] = [...initialTypeOrder].sort((a, b) => {
    if (!typeRankOrder || typeRankOrder.length === 0) return 0
    const aPublished = ticketsByType[a]?.[0]?.ticket_type_published
    const bPublished = ticketsByType[b]?.[0]?.ticket_type_published
    const aIdx = aPublished != null ? typeRankOrder.indexOf(aPublished) : -1
    const bIdx = bPublished != null ? typeRankOrder.indexOf(bPublished) : -1
    const aRank = aIdx === -1 ? Number.POSITIVE_INFINITY : aIdx
    const bRank = bIdx === -1 ? Number.POSITIVE_INFINITY : bIdx
    return aRank - bRank
  })

  return (
    <div className="space-y-6">
      {typeOrder.map((typeName) => {
        const ticketsOfType = ticketsByType[typeName]
        const firstTicketOfType = ticketsOfType[0]

        return (
          <div key={typeName}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {ticketsOfType.map((ticket, typeIndex) => {
                const isFirstOfThisType = ticket.id === firstTicketOfType.id

                return (
                  <BasicTicketCard
                    key={ticket.id}
                    ticket={ticket}
                    ticketIndex={typeIndex}
                    register={register}
                    getFieldState={getFieldState}
                    isSameAsContact={isSameAsContact[typeName] || false}
                    handleCheckboxChange={(e) => {
                      setIsSameAsContact((prev) => ({
                        ...prev,
                        [typeName]: e.target.checked,
                      }))
                    }}
                    isFirstTicketOfType={isFirstOfThisType}
                    watch={watch}
                    setValue={setValue}
                  />
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export { BasicFormsHandler }